import React from 'react'
import InputFill from '../form/InputFill'
import HeadingForm from '../elements/HeadingForm'
import Button from '../elements/Button'
import ModalForm from '../common/modal-form'

import { useTranslation } from 'react-i18next'

const ForgotPasswordModal = ({
    handleSubmit,
    form,
    handleInputChange,
    clearErrorField,
    errors,
    currentStep,
    isOpen,
    setIsOpen,
}) => {
    const { t } = useTranslation()

    const dataStep = [
        {
            title: t('forgotPassword.title'),
            fields: [
                {
                    label: t('customerInfo.email'),
                    name: 'email',
                    props: {
                        required: true,
                    },
                },
            ],
        },
        {
            title: t('forgotPassword.titleNewPassword'),
            fields: [
                {
                    label: t('customerInfo.otp'),
                    name: 'otp',
                    props: {
                        numberOnly: true,
                        required: true,
                    },
                },
                {
                    label: t('customerInfo.newPassword'),
                    name: 'newPassword',
                    props: {
                        type: 'password',
                        required: true,
                    },
                },
                {
                    label: t('customerInfo.confirmNewPassword'),
                    name: 'confirmNewPassword',
                    props: {
                        type: 'password',
                        required: true,
                        i18nDataError: {
                            minLength: 6,
                        },
                    },
                },
            ],
        },
    ]

    const currentData = dataStep[currentStep]

    return (
        <ModalForm centered isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <form onSubmit={handleSubmit} className="py-4 flex-1">
                <HeadingForm>{t(currentData.title)}</HeadingForm>

                {currentData.fields.map((field, index) => {
                    const Component = field.component || InputFill
                    return (
                        <div key={index}>
                            <Component
                                className="mt-6"
                                label={t(field.label)}
                                name={field.name}
                                value={form[field.name]}
                                error={errors[field.name]}
                                onChange={handleInputChange}
                                onFocus={() => clearErrorField(field.name)}
                                {...field.props}
                            />
                        </div>
                    )
                })}

                <div className="mt-8">
                    <Button fullWidth>{t('button.confirm')}</Button>
                </div>
            </form>
        </ModalForm>
    )
}

export default ForgotPasswordModal
